import api from '../services/api';

export type VendorType = 'INTERNAL' | 'EXTERNAL' | 'JOB_WORK_VENDOR' | 'SUPPLIER';

export interface Vendor {
  id: number;
  vendor_id?: string;
  registered_name: string;
  alias?: string;
  address?: string;
  phone: string;
  gst?: string;
  bank_account_name?: string;
  bank_account_no?: string;
  bank_ifsc_code?: string;
  vendor_type: VendorType;
  is_internal: boolean;
  created_at: string;
  updated_at: string;
  company_id: number;
}

export interface CreateVendorDTO {
  vendor_id?: string;
  registered_name: string;
  alias?: string;
  address?: string;
  phone: string;
  gst?: string;
  bank_account_name?: string;
  bank_account_no?: string;
  bank_ifsc_code?: string;
  vendor_type?: VendorType;
}

export interface UpdateVendorDTO extends Partial<CreateVendorDTO> {}

export interface BulkImportResult {
  created: number;
  updated: number;
  errors: { row: number; field: string; message: string }[];
}

const vendorApi = {
  getAll: async (params?: { vendor_type?: VendorType; is_internal?: boolean; search?: string }) => {
    const queryParams = new URLSearchParams();
    if (params?.vendor_type) queryParams.append('vendor_type', params.vendor_type);
    if (params?.is_internal !== undefined) queryParams.append('is_internal', params.is_internal.toString());
    if (params?.search) queryParams.append('search', params.search);

    const url = queryParams.toString() ? `/vendors?${queryParams.toString()}` : '/vendors';
    return await api.get(url);
  },
  
  getById: async (id: number) => {
    return await api.get(`/vendors/${id}`);
  },
  
  create: async (data: CreateVendorDTO) => {
    return await api.post('/vendors', data);
  },
  
  update: async (id: number, data: UpdateVendorDTO) => {
    return await api.put(`/vendors/${id}`, data);
  },
  
  delete: async (id: number) => {
    return await api.delete(`/vendors/${id}`);
  },

  bulkImport: async (vendors: CreateVendorDTO[]): Promise<BulkImportResult> => {
    const response = await api.post<BulkImportResult>('/vendors/import', { vendors });
    return response.data;
  },
};

export default vendorApi;
